<!-- 乡镇下村庄报修统计 -->

<template>
  <div class="main-area">
    <div v-if="$route.meta.rank == 3">
      <el-breadcrumb separator=":">
        <el-breadcrumb-item>当前位置</el-breadcrumb-item>
        <el-breadcrumb-item>报修情况数据统计</el-breadcrumb-item>
      </el-breadcrumb>

      <el-page-header @back="goBack" content="" class="margin-top-20"></el-page-header>

      <el-table style="width: 100%"
                :data="tableData"
                element-loading-text="数据处理中...请稍等..."
               @cell-click="changeIndex"
                v-loading="loading">
        <el-table-column prop="name" label="行政区划" align="center">
          <template slot-scope="scope">
            {{scope.row.name}}
            <!-- <router-link v-bind:to="'/villagesBXStatistics/townPeopleBXStatistics/'+scope.row.code + '/' + new Date().getTime()">{{scope.row.name}}</router-link> -->
          </template>
        </el-table-column>

        <el-table-column prop="pumpNum" label="报修次数" align="center"/>
      </el-table>
    </div>
    <div v-else><router-view></router-view></div>
  </div>
</template>

<script>
    export default {
        name: 'TownsBXStatistics',
        data() {
            return {
                // 查询表单
                searchForm: {
                    updateTime: ''
                },
                tableData: [

                ],
                loading: false,
                // 路由传递乡镇code
                villageCode: ''
            }
        },

        methods: {
            doSearch() {
                console.log("1111111111111");
            },
            // 分页方法
            tableSizeChange: function (pageSize) {
                this.pagination.pageSize = pageSize
                this.getTableData()
            },
            currentChange: function (current) {
                this.pagination.currentPage = current
                this.getTableData()
            },
            changeIndex (data) {
              this.$router.push({
                name: 'TownPeopleBXStatistics',
                params: {
                  townCode: data.code,
                  searchForm:this.searchForm
                }
              })
            },
            getTableData() {
                this.loading = true
                let _this = this, searchParams = this.searchForm
                let beginTime = ''
                let endTime = ''
                _this.FUNCTIONS.systemFunction.removeNullFields(searchParams)
                var reg = /-| |:/g
                 console.log(_this.searchForm)
                if (_this.searchForm.updateTime) {
                    if (_this.searchForm.updateTime[0]) {
                        beginTime = _this.searchForm.updateTime[0].replace(reg, '') + '00'
                    }
                    if (_this.searchForm.updateTime[1]) {
                        endTime = _this.searchForm.updateTime[1].replace(reg, '') + '00'
                    }
                }
                // 3、 调接口获取数据
                let param = {
                    // baseService : "TGcBxxxServiceImpl",
                    baseService: _this.GLOBAL.config.baseServiceType.TGcBxxxServiceImpl,
                    code: _this.villageCode,
                    beginTime: beginTime,
                    endTime: endTime,
                    type:"1"

                }
                // _this.FUNCTIONS.systemFunction.jsonPost(
                //     _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
                //     param,
                _this.FUNCTIONS.systemFunction.interactiveData(
                    _this,
                    _this.GLOBAL.config.businessFlag.zxUser,
                    // "getVillagesCommittee",
                    _this.GLOBAL.config.handleType.getVillagesCommittee,
                    param,
                    null,
                    resultData => {
                        _this.loading = false
                        if (resultData) {
                            // 结果参数赋值
                            _this.tableData = resultData.obj;
                        } else {
                            _this.$message.warning('获取列表数据失败～')
                        }
                    },
                    () => {
                        _this.loading = false
                    }
                )
            },
            goBack() {
                this.$router.go(-1);
            }
        },
        mounted() {
            this.villageCode = this.$route.params.villageCode;
            if(this.$route.params.searchForm){
            this.searchForm = this.$route.params.searchForm
            }
            this.getTableData();
        }
    }
</script>

<style scoped>
  a {
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/view/statistics/TownsBXStatistics.vue